import { useState } from 'react';

import {
  Grid,
  FormControl,
  OutlinedInput,
  InputAdornment,
  IconButton,
  FormHelperText,
} from '@material-ui/core';
import { makeStyles } from '@material-ui/core/styles';

import PropTypes from 'prop-types';

import { Icon, Image } from '@/src/components/atoms';
import { SectionHeader } from '@/src/components/molecules';
import useRDStation from '@/src/lib/rdstation/useRDStation';

const useStyles = makeStyles(theme => ({
  inputContainer: {
    display: 'flex',
    justifyContent: 'flex-start',
  },
  formControl: {
    maxWidth: 400,
  },
  image: {
    width: 400,
    [theme.breakpoints.down('md')]: {
      width: 300,
    },
  },
}));

export default function FooterNewsletter({ className, ...rest }) {
  const classes = useStyles();
  const [input, setInput] = useState('');
  const { message, error, loading, subscribe } = useRDStation();

  const handleSubscribe = () =>
    subscribe({
      email: input,
      conversionIdentifier: 'newsletter',
      campaign: 'explore',
      onSuccess: () => setInput(''),
    });

  return (
    <div className={className} {...rest}>
      <Grid container spacing={4}>
        <Grid item xs={12} sm={6} container>
          <Image
            src="/images/illustrations/newsletters/newsletter-3.svg"
            className={classes.image}
            alt="Mulher lendo mensagem"
          />
        </Grid>
        <Grid item xs={12} sm={6} container alignItems="center">
          <div>
            <SectionHeader
              title={<span>Quer receber nossas novidades?</span>}
              subtitle={
                <span>
                  Receba em primeira mão novidades e atualizações sobre nossa plataforma e
                  ecossistema.
                </span>
              }
              fadeUp
              align="left"
            />
            <div className={classes.inputContainer}>
              <FormControl
                fullWidth
                error={error}
                disabled={loading}
                variant="outlined"
                data-aos="fade-up"
                className={classes.formControl}>
                <OutlinedInput
                  endAdornment={
                    <InputAdornment position="end">
                      <IconButton onClick={handleSubscribe}>
                        <Icon fontIconClass="fas fa-paper-plane" />
                      </IconButton>
                    </InputAdornment>
                  }
                  placeholder="Coloque seu e-mail aqui e aperte 'Enter'"
                  value={input}
                  onChange={evt => setInput(evt.target.value)}
                  onKeyPress={evt => {
                    if (evt.key === 'Enter') {
                      handleSubscribe();
                      evt.preventDefault();
                    }
                  }}
                />
                {message && <FormHelperText error={error}>{message}</FormHelperText>}
              </FormControl>
            </div>
          </div>
        </Grid>
      </Grid>
    </div>
  );
}

FooterNewsletter.propTypes = {
  className: PropTypes.string,
};
